import { render, staticRenderFns } from "./PDialog.vue?vue&type=template&id=080dd13e&"
import script from "./PDialog.vue?vue&type=script&lang=js&"
export * from "./PDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports